// components/Layout.js
import Header from './Header'
import Menu from './Menu'
import { Outlet } from 'react-router-dom'  // Este es el lugar donde se renderizan las páginas

const Layout = () => {
    return (
        <div>
            <Header />
            <div className='flex min-h-[calc(100vh-50px)]'>
                <Menu />
                 <Outlet />  {/* Aquí se cargan las páginas específicas */}   
            </div>
        </div>
    )
}

export default Layout
